export function checkInvalidToken(data: any) {
    if (!data) return false;
    if (data.status === 403) {
        // Remove token
        localStorage.removeItem("authToken");

        // Redirect user to login
        window.location.href = "/login";

        return true;
    }
    return false;
}
